export function createTabSearch<const T extends readonly string[]>(tabs: T) {
	return (search: Record<string, unknown>): { tab?: T[number] } =>
		typeof search.tab === "string" &&
		(tabs as readonly string[]).includes(search.tab)
			? { tab: search.tab as T[number] }
			: {}
}
